<template>
  <div>
    <div v-if="loading">
      <loader :loading="loading" />
    </div>

    <div v-else class="card p-3">
      <!-- <div class="d-flex flex-row-reverse">
        <div>نیاز به اصلاح</div>
      </div> -->
      <Section :line="false">
        <div>
          <a class="text-decoration-underline link" @click="redirectToPublicCoursePage"> نمایش صفحه دوره </a>
        </div>
      </Section>

      <Section title="عنوان دوره" :line="false">
        <h6 class="title">{{ model.title }}</h6>
      </Section>

      <Section title="توضیحات دوره" :line="false">
        <div v-html="model.fullDescription" style="line-height: 2rem; padding: 1rem" />
      </Section>

      <Section title="موضوع دوره" :line="false">
        <h6 class="title">{{ model.categoryTitle }}</h6>
      </Section>

      <Section title="سرفصل ها" :line="false" backgroundClass>
        <div v-for="(session, index) in model.sessions" :key="index" class="d-flex align-items-center gap-3 p-3 my-2 sessions">
          <p class="px-3 session_index">{{ index + 1 }}</p>

          <p style="margin: 0">{{ session.title }}</p>
        </div>
      </Section>

      <Section v-if="model.extraDescription !== null" title="توضیحات تکمیلی" :line="false">
        <div v-html="model.extraDescription" style="line-height: 2rem; padding: 1rem" />
      </Section>

      <Section :line="false">
        <div>
          <a class="text-decoration-underline sub_link" @click="redirectToWorkOutStudentsPage">تمرین های ارسالی دانش پذیران</a>
        </div>
      </Section>

      <div class="align-self-end p-3">
        <b-button variant="primary" @click="$router.go(-1)">بازگشت به لیست دوره ها</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import Section from '../../../components/common/form/Section.vue'
import loader from '../../../components/common/loader.vue'
import skillUpTeacherProvider from '../../../services/skillUp/teacher.js'

export default {
  components: { Section, loader },
  data() {
    return {
      loading: false,
      courseCategoryTitle: '',
      model: {},
    }
  },
  methods: {
    async fetchCourse() {
      this.loading = true
      try {
        const req = await skillUpTeacherProvider.getCourse(this.$route.params.courseId)
        this.model = req.data.data.output
      } catch (error) {
        this.loading = false
      } finally {
        this.loading = false
      }
    },
    redirectToPublicCoursePage() {
      const href = `https://skillup.ut.ac.ir/course/${this.$route.params.courseId}`
      window.open(href, '_blank')
    },
    redirectToWorkOutStudentsPage() {
      const query = this.model.title
      if (this.$route.path.includes('teacher')) {
        localStorage.setItem('courseName', query)
        const href = '/list/teacherskilluppractice'
        window.open(href, '_blank')
      }
    },
  },

  mounted() {
    this.fetchCourse()
  },
}
</script>

<style lang="scss" scoped>
.link {
  color: rgba(85, 110, 230, 1);
  text-shadow: 4px 4px 3px rgba(0, 0, 0, 0.25);
  font-weight: 700;
  font-size: 13px;
  cursor: pointer;
}

.sub_link {
  color: rgba(85, 110, 230, 1);
  text-shadow: 4px 4px 3px rgba(0, 0, 0, 0.25);
  font-weight: 500;
  font-size: 13px;
  cursor: pointer;
}

.title {
  font-weight: 300;
  font-size: 16px;
  color: rgba(0, 0, 0, 1);
  margin: 0;
}

.sessions {
  background: rgba(85, 110, 230, 0.09);
  border-radius: 5px;
}

.session_index {
  border-left: 1px solid rgba(2, 142, 155, 1);
  margin: 0;
  font-size: 17px;
  width: 50px;
}
</style>
